export default "__VITE_ASSET__CSlgZFGB__"